import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Logout = () => {
    const navigate = useNavigate();
    //Clear authentication state and redirect to login page
    useEffect(() =>{
        navigate("/auth");
    },[])
    return null;
    
};

export default Logout;